// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AtIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 0 0 0 26c2.689 0 5.512-.81 7.554-2.166a.998.998 0 0 0 .28-1.387 1.002 1.002 0 0 0-1.388-.28C20.75 26.297 18.276 27 16 27a11 11 0 1 1 11-11c0 3.306-1.36 4-2.5 4s-2.5-.694-2.5-4v-5a1 1 0 0 0-2 0v.533a6 6 0 1 0 .741 8.137c.75 1.5 2.044 2.33 3.759 2.33 2.817 0 4.5-2.242 4.5-6A13.013 13.013 0 0 0 16 3Zm0 17a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
